import uniqid from "uniqid";
import UIkit from "uikit";
import $ from "jquery";
import { API_HOST } from "../../api_utils";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RegistrationTemplatePlugin = (editor, options) => {
  const notifyTheme = {
    position: "top-right",
    autoClose: 7500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  const notifyTheme2 = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  const successTheme = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  // toast notification for empty tables
  const infoTheme = {
    position: "top-right",
    autoClose: 7500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  if (editor !== null && editor !== undefined) {
    editor.Blocks.add("registration-template", {
      label: "Registration Template",
      category: "Business",
      select: true,
      media: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16"><path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/></svg>`,
      content: { type: "registration-template" },
    });

    editor.DomComponents.addType("registration-template", {
      model: {
        defaults: {
          tagName: "div",
          type: "registration-template",
          attributes: { class: "registration-template" },
          copyable: false,
          "style-default": {
            background: "-webkit-linear-gradient(left, #3931af, #00c6ff)",
            "margin-top": "3%",
            padding: "3%",
          },

          style: {
            background: "-webkit-linear-gradient(left, #3931af, #00c6ff)",
            "margin-top": "3%",
            padding: "3%",
          },

          styles: `
        @media only screen and (max-width: 480px) {
          .registration-template {
            min-height: 100vh;
            height: auto !important;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            margin: 0;
            padding: 3%;
            position: relative;
          }
          
          body {
            min-height: 100vh;
            height: 100%;
          }
        }
      `,

          components: [
            {
              tagName: "div",
              type: "header",
              attributes: { class: "row" },
              components: [
                // Left Column
                {
                  tagName: "div",
                  type: "left-column",
                  attributes: { class: "col-md-3 register-left" },
                  "style-default": {
                    "text-align": "center",
                    color: "#fff",
                    "margin-top": "8%",
                  },
                  style: {
                    "text-align": "center",
                    color: "#fff",
                    "margin-top": "8%",
                  },
                  styles: `
            @media only screen and (max-width: 480px) {
              .row {
                min-height: 100%;
                height: auto !important;
                display: flex;
                flex-direction: column;
                position: relative;
              }
            }
          `,
                  components: [
                    {
                      tagName: "h3",
                      type: "left-data",
                      content: "Welcome",
                      "style-default": {
                        color: "#fff",
                        "font-weight": "bold",
                      },
                      style: {
                        color: "#fff",
                        "font-weight": "bold",
                      },
                    },
                    {
                      tagName: "p",
                      type: "left-data1",
                      content:
                        "Welcome aboard! Let's get you signed up in just a few steps.",
                      "style-default": {
                        "font-weight": "lighter",
                        padding: "12%",
                        "margin-top": "-9%",
                      },
                      style: {
                        "font-weight": "lighter",
                        padding: "12%",
                        "margin-top": "-9%",
                      },
                    },
                  ],
                },
                {
                  tagName: "div",
                  type: "right-column",
                  attributes: { class: "col-md-9 register-right" },
                  "style-default": {
                    background: "#f8f9fa",
                    "border-top-left-radius": "10% 50%",
                    "border-bottom-left-radius": "10% 50%",
                  },
                  style: {
                    background: "#f8f9fa",
                    "border-top-left-radius": "10% 50%",
                    "border-bottom-left-radius": "10% 50%",
                  },
                  styles: `
                @media only screen and (max-width: 480px) {
                  .register-right {
                    border-radius: 15px;
                    margin-top: 20px;
                    height: auto !important;
                    min-height: fit-content;
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    position: relative;
                  }
                }
              `,
                  components: [
                    {
                      tagName: "h3",
                      type: "right-data1",
                      attributes: { class: "register-heading" },
                      content: "Get Started",
                      "style-default": {
                        "text-align": "center",
                        "margin-top": "8%",
                        "margin-bottom": "-15%",
                        color: "#495057",
                      },
                      style: {
                        "text-align": "center",
                        "margin-top": "8%",
                        "margin-bottom": "-15%",
                        color: "#495057",
                      },
                    },
                    {
                      tagName: "div",
                      type: "right-data2",
                      attributes: { class: "row register-form" },
                      "style-default": {
                        padding: "10%",
                        "margin-top": "10%",
                      },
                      style: {
                        padding: "10%",
                        "margin-top": "10%",
                      },
                      styles: `
                    @media only screen and (max-width: 480px) {
                      .register-form {
                        padding: 5%;
                        margin-top: 5%;
                        height: auto !important;
                        min-height: fit-content;
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                      }
                    }
                  `,
                      components: [
                        {
                          tagName: "div",
                          type: "left-form",
                          attributes: { class: "col-md-6" },
                          components: [
                            {
                              tagName: "div",
                              type: "left-form-data1",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "First Name",
                                    name: "textField",
                                    type: "text",
                                  },
                                },
                              ],
                            },
                            {
                              tagName: "div",
                              type: "left-form-data2",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "Last Name",
                                    name: "textField",
                                    type: "text",
                                  },
                                },
                              ],
                            },
                            {
                              tagName: "div",
                              type: "left-form-data3",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "Password",
                                    name: "textField",
                                    type: "password",
                                  },
                                },
                              ],
                            },
                            {
                              tagName: "div",
                              type: "left-form-data4",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "Confirm Password",
                                    name: "textField",
                                    type: "password",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        // Right Form Column
                        {
                          tagName: "div",
                          type: "right-form",
                          attributes: { class: "col-md-6" },
                          components: [
                            {
                              tagName: "div",
                              type: "left-form-data1",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "Email",
                                    name: "textField",
                                    type: "email",
                                  },
                                },
                              ],
                            },
                            {
                              tagName: "div",
                              type: "left-form-data2",
                              attributes: { class: "form-group" },
                              components: [
                                {
                                  type: "default",
                                  tagName: "input",
                                  style: {
                                    "flex-grow": "1",
                                    display: "block",
                                    width: "100%",
                                    padding: "0.375rem 0.75rem",
                                    height: "calc(1.5em + 0.75rem + 2px)",
                                    "font-size": "1rem",
                                    "font-weight": "400",
                                    "line-height": "1.5",
                                    color: "#495057",
                                    "background-color": "#fff",
                                    "background-clip": "padding-box",
                                    border: "1px solid #ced4da",
                                    "border-radius": "0.25rem",
                                    transition:
                                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                                  },
                                  attributes: {
                                    placeholder: "Phone Number",
                                    name: "textField",
                                    type: "number",
                                  },
                                },
                              ],
                            },
                            {
                              tagName: "button",
                              type: "left-form-data4-registerButton",
                              attributes: {
                                class: "btnRegister",
                              },
                              content: "Register",
                              "style-default": {
                                float: "right",
                                "margin-top": "10%",
                                "margin-right": "8%",
                                border: "none",
                                "border-radius": "1.5rem",
                                padding: "0.375rem 0.75rem",
                                height: "calc(1.5em + 0.75rem + 2px)",
                                background: "#0062cc",
                                color: "#fff",
                                "font-weight": "600",
                                width: "80%",
                                cursor: "pointer",
                              },
                              style: {
                                float: "right",
                                "margin-top": "10%",
                                "margin-right": "8%",
                                border: "none",
                                "border-radius": "1.5rem",
                                padding: "0.375rem 0.75rem",
                                height: "calc(1.5em + 0.75rem + 2px)",
                                background: "#0062cc",
                                color: "#fff",
                                "font-weight": "600",
                                width: "80%",
                                cursor: "pointer",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    });
  }
};

export default RegistrationTemplatePlugin;
